import React from "react";
import * as S from "./styled";

const SessionThree = ()=>{
    return(
        <S.SessionContainer id="project">
            <S.SeThreeTitle>프로젝트 진행중 입니다</S.SeThreeTitle>
            <S.SeThreeText>COMMING SOON...</S.SeThreeText>
        </S.SessionContainer>
    )
}

export default SessionThree